import elementTextFilter from '../../../../modules/Gull/Framework/elementTextFilter.js';

const selectUserId = {

	init: function() {

		const elementTextFilterElement = document.querySelector('[data-element-text-filter-input]');
		elementTextFilter.init(elementTextFilterElement);

	},

};

export default selectUserId;
